/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasSchema } from '../../openapi/models/OasSchema';

/**
 * A command used to delete all properties from a schema.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllPropertiesCommand extends AbstractCommand {
    public _schemaPath : NodePath;

    public _oldProperties : Array<any>;

    public constructor(schema? : any) {
        if(((schema != null && schema instanceof <any>OasSchema) || schema === null)) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
            (() => {
                this._schemaPath = Library.createNodePath(schema);
            })();
        } else if(schema === undefined) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllPropertiesCommand] Executing.");
        this._oldProperties = <any>([]);
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        schema.getPropertyNames().forEach(((schema) => {
            return (pname) => {
                let data : any = JsonCompat.objectNode();
                JsonCompat.setPropertyString(data, Constants.PROP_NAME, pname);
                JsonCompat.setProperty(data, Constants.PROP_SCHEMA, Library.writeNode(schema.removeProperty(pname)));
                JsonCompat.setPropertyBoolean(data, Constants.PROP_REQUIRED, this.isPropertyRequired(schema, pname));
                /* add */(this._oldProperties.push(data)>0);
            }
        })(schema));
        schema.required = null;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllPropertiesCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldProperties) || /* size */(<number>this._oldProperties.length) === 0) {
            return;
        }
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        if(this.isNullOrUndefined(schema.required)) {
            schema.required = <any>([]);
        }
        this._oldProperties.forEach(((schema) => {
            return (oldProp) => {
                let name : string = JsonCompat.getPropertyString(oldProp, Constants.PROP_NAME);
                let schemaObj : any = JsonCompat.getProperty(oldProp, Constants.PROP_SCHEMA);
                let required : boolean = JsonCompat.getPropertyBoolean(oldProp, Constants.PROP_REQUIRED);
                let prop : OasSchema = schema.createPropertySchema(name);
                Library.readNode(schemaObj, prop);
                schema.addProperty(name, prop);
                if(ModelUtils.isDefined(required) && required === true) {
                    /* add */(schema.required.push(name)>0);
                }
            }
        })(schema));
    }

    /**
     * Returns true if the property is required.
     * @param {OasSchema} schema
     * @param {string} propertyName
     * @return {boolean}
     * @private
     */
    /*private*/ isPropertyRequired(schema : OasSchema, propertyName : string) : boolean {
        return ModelUtils.isDefined(schema.required) && schema.required.indexOf(propertyName) !== -1;
    }
}
DeleteAllPropertiesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllPropertiesCommand";
DeleteAllPropertiesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

